import { axiosInstance } from "./axiosSetup";
import { handleErrors } from "./handleErrors";
import {
    googleOauthUrl,
    hubApiBaseUrl,
    microsoftOauthUrl
} from "../constants";

export const authorize = (credentials) => {
    return axiosInstance.post("authorize", credentials);
};

export const getGoogleClientId = async () => {
    return axiosInstance.get('authorize/google/client-id').catch(handleErrors);
};

export const createGoogleOauthUrl = (clientId, flow, additionalParameterName, additionalParameterValue) => {
    const apiCallbackUrl = `${hubApiBaseUrl}/authorize/google/callback`;
    const apiCallbackUrlEncoded = encodeURIComponent(apiCallbackUrl);

    const scope = encodeURIComponent('openid email profile');

    const googleOauthUrlObject = new URL(googleOauthUrl);
    googleOauthUrlObject.searchParams.append('client_id', clientId);
    googleOauthUrlObject.searchParams.append('redirect_uri', apiCallbackUrlEncoded);
    googleOauthUrlObject.searchParams.append('response_type', 'code');
    googleOauthUrlObject.searchParams.append('scope', scope);

    const stateObj = { apiCallbackUrl, flow };
    if (additionalParameterName && additionalParameterValue) {
        stateObj[additionalParameterName] = additionalParameterValue;
    }
    const stateJson = JSON.stringify(stateObj);
    const stateBase64 = btoa(stateJson);
    googleOauthUrlObject.searchParams.append('state', stateBase64);

    return decodeURIComponent(googleOauthUrlObject.toString());
};

export const getMicrosoftTenantId = async () => {
    return axiosInstance.get('authorize/microsoft/tenant-id').catch(handleErrors);
};

export const getMicrosoftClientId = async () => {
    return axiosInstance.get('authorize/microsoft/client-id').catch(handleErrors);
};

export const createMicrosoftOauthUrl = (tenantId, clientId, flow, additionalParameterName, additionalParameterValue) => {
    const apiCallbackUrl = `${hubApiBaseUrl}/authorize/microsoft/callback`;
    const apiCallbackUrlEncoded = encodeURIComponent(apiCallbackUrl);

    const scope = encodeURIComponent('openid email profile');

    const microsoftOauthUrlObject = new URL(microsoftOauthUrl);
    microsoftOauthUrlObject.searchParams.append('client_id', clientId);
    microsoftOauthUrlObject.searchParams.append('redirect_uri', apiCallbackUrlEncoded);
    microsoftOauthUrlObject.searchParams.append('response_type', 'code');
    microsoftOauthUrlObject.searchParams.append('scope', scope);
    microsoftOauthUrlObject.searchParams.append('response_mode', 'query');

    const stateObj = { apiCallbackUrl, flow };
    if (additionalParameterName && additionalParameterValue) {
        stateObj[additionalParameterName] = additionalParameterValue;
    }
    const stateJson = JSON.stringify(stateObj);
    const stateBase64 = btoa(stateJson);
    microsoftOauthUrlObject.searchParams.append('state', stateBase64);

    return decodeURIComponent(microsoftOauthUrlObject.toString());
};
